export const validateNhsno = (val) => {
    // is it all digits and exactly 10 numbers long
    if (!/^\d+$/.test(val)) {
        return false;
    }

    if (val.length !== 10) {
        return false;
    }

    // see if the check digit matches - this is the best we can do locally
    // algorithm from https://www.datadictionary.nhs.uk/attributes/nhs_number.html
    // number generator: http://danielbayley.uk/nhs-number/
    let total = 0;
    let remainder = 0;
    const checkDigit = parseInt(val[val.length - 1], 10);

    // steps 1 and 2 - multiply first 9 digits by weighting; 10th digit is the check digit
    for (let i = 0; i < val.length - 1; i++) {
        const weighting = 10 - i;
        total += parseInt(val[i], 10) * weighting;
    }

    // step 3 - get the remainder mod 11
    remainder = total % 11;

    // step 4 - subtract from 11 to give check digit
    remainder = 11 - remainder;
    remainder = remainder === 11 ? 0 : remainder;

    // step 5 - check that the remainder is valid and matches the check digit; 10 is definitely invalid
    if (remainder === 10 || remainder !== checkDigit) {
        return false;
    }

    return true;
};